<template>
	<section id="revistas">
		<div id="breadcrumbs">
			<div class="bg-light py-3">
				<div class="container">
					<div class="row">
						<div class="col-md-12 mb-0 text-left">
							<router-link to="/">Home</router-link> <span class="mx-2 mb-0">/</span> <strong class="text-black">Revistas</strong>
						</div>
					</div>
				</div>
			</div>
		</div><!-- #breadcrumbs -->
		<ProductList :no_product="message" :products="subscriptions"></ProductList>
		<img loading="lazy" src="images/img_estilos/Revista desk.svg" alt="revistas" width="225" height="100">
		<div class="row">
			<div class="col-12">
				<div class="btn-group" role="group" aria-label="Year magazines">
					<button type="button" class="btn btn-outline-dark" @click="getMagazines(y)" v-for="y in last_years">{{ y}}</button>
				</div>
			</div>
		</div>
		<loading :active.sync="is_loading"></loading>
		<ProductList :no_product="message" :products="products"></ProductList>
		<div class="my-2" v-show="current_year == 2017">
			<p class="h5">Si necesitan mas revistas ponerse en contacto en <a href="mailto:sos@revistamoi.com">sos@revistamoi.com</a></p>
		</div>
	</section>
</template>

<script>
// @ is an alias to /src
import ProductList from '@/components/ProductList.vue';
import Loading from 'vue-loading-overlay';
const axios = require('axios');


export default {
	name: 'revista',
	data(){
		return {
			api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
			products: [],
			message: "",
			current_year: new Date().getFullYear(),
			is_loading: true,
			last_years: [],
			subscriptions: [],
		}
	},
	components: {
		ProductList,
		Loading
	},
	mounted() {
		this.getRevistas();
		for (var y = this.current_year; y >= 2017; y--){
			this.last_years.push(y);
		}
		this.getSubscriptions();
		this.getDigitalSubscriptions();
	},
	methods: {
		getRevistas: function(){
			var year = new Date().getFullYear();
			this.message = "Cargando revistas";
			axios({
				method: 'GET',
				url: this.api_url+'/products/type/1/year/'+year,
				headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+$cookies.get('ctoken')}
			})
				.then(response => {
					this.products = response.data;
					console.info('Se obtuvieron las revistas');
					console.info(response.data);
					this.is_loading = false;
					if (this.products.length > 0)
						this.message = "Se obtuvieron las revistas";
					else
						this.message = "No se encontraron revistas que mostrar";
				})
				.catch(error => {
					console.error(error);
					this.message = "No se encontraron revistas que mostrar";
				});
		},
		getMagazines: function(year){
			this.current_year = year;
			this.is_loading = true;
			axios({
				method: 'GET',
				url: this.api_url+'/products/type/1/year/'+year,
				headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+$cookies.get('ctoken')}
			})
				.then(response => {
					this.products = response.data;
					console.info('Se obtuvieron las revistas');
					console.info(response.data);
					this.is_loading = false;
					if (this.products.length > 0)
						this.message = "Se obtuvieron las revistas";
					else
						this.message = "No se encontraron revistas que mostrar";
				})
				.catch(error => {
					console.error(error);
					this.message = "No se encontraron revistas que mostrar";
				});
		},
		getSubscriptions: function () {
			// Se hace la petcion de las suscripciones normales
			axios({
				method: "GET",
				url: this.api_url + "/products/type/3",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de suscripciones");
					console.info(response.data);
					if (response.data.length > 0) this.subscriptions = this.subscriptions.concat(response.data);
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron suscripciones que mostrar";
				});
		},
		getDigitalSubscriptions: function(){
			axios({
				method: "GET",
				url: this.api_url + "/products/type/6",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de suscripciones digitales");
					if (response.data.length > 0)
						this.subscriptions = this.subscriptions.concat(response.data);
				})
				.catch((error) => {
					console.log(error);
					this.message = "No se encontraron suscripciones digitales que mostrar";
				})
		},
	}
}
</script>
